import { Edit } from "@styled-icons/boxicons-solid";
import { colors } from "constants/colors";
import styled from "styled-components";
import { newColors } from "constants/newColors";
import { fontSize } from "constants/fontSize";

export const StyledEditableNameplate = styled.div`
  display: flex;
  width: 100%;
`;
export const StyledForm = styled.form`
  width: 100%;
`;

export const StyledEditableInputText = styled.input`
  width: 90%;
  font-size: ${fontSize.small};
  padding: 0.5rem;
  box-sizing: border-box;
  border-radius: 5px;
  border: 0px;
  outline: none;
  background: ${colors.form.background};
`;

export const StyledEditIcon = styled(Edit)`
  color: ${newColors.iconGray};
  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
`;

export const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const StyledTypoDiv = styled.div`
  width: 95%;
`;
